/**
 * @generated SignedSource<<ec385566b66c7f29feb2fa1edd9f5cc0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BasicMetadata = {
  description?: string | null | undefined;
  title: string;
};
export type PlaylistDetailsMetadataMutation$variables = {
  id: string;
  metadata: BasicMetadata;
};
export type PlaylistDetailsMetadataMutation$data = {
  readonly updatePlaylist: {
    readonly id: string;
  };
};
export type PlaylistDetailsMetadataMutation = {
  response: PlaylistDetailsMetadataMutation$data;
  variables: PlaylistDetailsMetadataMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "metadata"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "metadata",
        "variableName": "metadata"
      }
    ],
    "concreteType": "AuthorizedPlaylist",
    "kind": "LinkedField",
    "name": "updatePlaylist",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PlaylistDetailsMetadataMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PlaylistDetailsMetadataMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "eba4434df00ce7f2c9b972387826be59",
    "id": null,
    "metadata": {},
    "name": "PlaylistDetailsMetadataMutation",
    "operationKind": "mutation",
    "text": "mutation PlaylistDetailsMetadataMutation(\n  $id: ID!\n  $metadata: BasicMetadata!\n) {\n  updatePlaylist(id: $id, metadata: $metadata) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "089045b3b4355e4c707d017769b0f028";

export default node;
